import { ReactNode } from 'react'
import { Box, Text, Stack, IconCheck } from '@machobear/design-system'
import { breakpoints } from '@machobear/design-system/css'

import useMediaQuery from '@/hooks/use-media-query'

interface ChecklistItemProps {
  index: number
  isComplete: boolean
  title: ReactNode
  subtitle: ReactNode
  children: ReactNode
}

const ChecklistItem = ({ index, title, subtitle, children, isComplete }: ChecklistItemProps) => {
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.tablet}px)`)
  return (
    <Box
      padding="small"
      display="flex"
      justifyContent="flexStart"
      background="neutralLight"
      borderRadius="standard"
    >
      <Box style={{ width: '40px', height: '40px' }}>
        {isComplete ? (
          <Box
            borderRadius="circle"
            display="flex"
            justifyContent="center"
            alignItems="center"
            background="positive"
            style={{
              width: '40px',
              height: '40px',
              fontWeight: 'bold'
            }}
          >
            <IconCheck />
          </Box>
        ) : (
          <Box
            border="borderNeutralLight"
            borderRadius="circle"
            display="flex"
            justifyContent="center"
            alignItems="center"
            background="white"
            style={{ width: '40px', height: '40px', fontWeight: 'bold', borderWidth: '2px' }}
          >
            {index}
          </Box>
        )}
      </Box>
      <Box
        display="flex"
        flexDirection={displayMobile ? 'column' : 'row'}
        marginLeft={displayMobile ? 'small' : 'gutter'}
        width="full"
      >
        <Box
          style={{ maxWidth: displayMobile ? 'unset' : '330px' }}
          marginRight={displayMobile ? 'none' : 'xlarge'}
          marginBottom={displayMobile ? 'small' : 'none'}
        >
          <Stack space="xsmall">
            <Text
              weight={isComplete ? 'regular' : 'strong'}
              tone={isComplete ? 'disabled' : 'neutral'}
            >
              <Box component={isComplete ? 's' : 'span'}>{title}</Box>
            </Text>
            <Text tone={isComplete ? 'disabled' : 'tertiary'} size="small">
              <Box component={isComplete ? 's' : 'span'}>{subtitle}</Box>
            </Text>
          </Stack>
        </Box>
        {children}
      </Box>
    </Box>
  )
}

export default ChecklistItem
